module.exports = __webpack_public_path__ + "img/15_Fotokonstrukteur_Foto_2020.5f9db153.jpg";